import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TcgService {
  private configId: string = "";
  private storyKeys: any = [];
  private selectedRows = new BehaviorSubject<any>(null);
  private deSelectedRows = new BehaviorSubject<any>(null);
  private isSelecteAll = new BehaviorSubject<any>(null);

  setConfigId(configId: string) {
    this.configId = configId;
  }

  getConfigId() {
    return this.configId;
  }

  setStoryKeys(storyKeys: any[]) {
    this.storyKeys = storyKeys;
  }

  getStoryKeys() {
    return this.storyKeys;
  }

  setSelectedRows(projectId: string): void {
    this.selectedRows.next(projectId);
  }

  getSelectedRows(): Observable<string | null> {
    return this.selectedRows.asObservable();
  }

  setDeSelectedRows(projectId: string): void {
    this.deSelectedRows.next(projectId);
  }

  getDeSelectedRows(): Observable<string | null> {
    return this.deSelectedRows.asObservable();
  }
  
  setSelectedStatus(status: boolean): void {
    this.isSelecteAll.next(status);
  }

  getSelectedStatus(): Observable<boolean | null> {
    return this.isSelecteAll.asObservable();
  }

  
}
